/**
 * Post media preview gallery.
 */
export default function (current, all) {
    all.unshift(current);
    return {
        current: current,
        all: all,
        next: function () {
            this.current = this.all.includes(this.current + 1) ? this.current + 1 : this.all[0];
        },
        previous: function () {
            this.current = this.all.includes(this.current - 1)
                ? this.current - 1
                : this.all[this.all.length - 1];
        },
    };
}
